






























import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'

@Component({})
export default class AppHorizontalSlideController extends Vue {
  @Prop({ type: [Number, String], default: 72 }) readonly width!: number | string
  @Prop({ type: [Number, String], default: 22 }) readonly height!: number | string
  @Prop({ type: String }) readonly background!: string
  @Prop({ type: Boolean, default: false }) readonly disableLeft!: boolean
  @Prop({ type: Boolean, default: false }) readonly disableRight!: boolean

  @Emit('left')
  toLeftHandler () {
    // do nothing
  }

  @Emit('right')
  toRightHandler () {
    // do nothing
  }
}
